/* eslint-disable eqeqeq */
import React, { useEffect } from 'react';

import PlayerTagsFilter from '../Filters/PlayerTagsFilter';
import PlayerAgeTagsFilter from '../Filters/PlayerAgeTagsFilter';
import UtrFilter from '../Filters/UtrFilter';
import GenderFilter from '../Filters/GenderFilter';
import HSGradYearFilter from '../Filters/HSGradYearFilter';
import NationalityFilter from '../Filters/NationalityFilter';
import CollegesFilter from '../Filters/CollegesFilter';
import PlayersMoreMobileFilter from '../Filters/PlayersMoreMobileFilter';

import useStartPowerCheckout from '../../../components/hooks/useStartPowerCheckout';
import { PowerFunnelSurfaces } from '../../../components/Analytics/constants';
import { getGatedFeatureForFilter } from '../../../components/Analytics/helpers';

const PlayerFilters = (props) => {
    const {
        search,
        handleFilterClick,
        state,
        userLoggedIn,
        isPowerUser,
        _this,
        filterInputs,
        searchTypes,
        auth,
        filterType,
    } = props;

    const { startPowerCheckout } = useStartPowerCheckout();
    const { filters = {} } = search;
    const { sportTypes } = filters;
    const { tennis, pickleball } = sportTypes || {};
    const showTennisContent = auth?.feedPreferences?.showTennisContent;
    const showPickleballContent = !!auth?.feedPreferences?.showPickleballContent;
    const isTennisSelected = !!tennis;
    const isTennisAndPickleballSelected = !!tennis && !!pickleball;

    const playerFiltersAreActive = (search.filters && (
        filters.gender || filters.utrMin > 1 || filters.utrMax < 16 || filters.college || filters.division || filters.conference ||
        filters.ageTag || (filters.ageMin || filters.ageMax) || filters.nationality || (filters.hsGradYears && Object.values(filters.hsGradYears).indexOf(true) > -1))
    );
    // TODO: eqeqeq rule disabled until we validate state.filterModal is always a string
    const commonFilterProps = {
        filters,
        filterInputs,
        handleFilterClick,
        filterModal: state.filterModal,
        closeModals: _this.closeModals,
        handleFilterSubmit: _this.handleFilterSubmit,
        clearFilters: _this.clearFilters,
        handleFilterUpdate: _this.handleFilterUpdate,
    };

     useEffect(() => {
        _this.handleFilterSubmit({
            sportTypes: {
                tennis: auth?.user ? showTennisContent : true,
                pickleball: auth?.user ? showPickleballContent : true,
            },
        });
    }, [filterType]);

    const handleOnUpgradeToPowerClick = (filterName) => {
        startPowerCheckout({
            surface: PowerFunnelSurfaces.PLAYER_SEARCH_PAGE,
            gatedFeature: getGatedFeatureForFilter(filterName),
            confirmResume: true,
        });
    };

    return (
        <>
            <PlayerTagsFilter
                {...commonFilterProps}
                searchTypes={searchTypes}
                data-testid="search.players.filter.segment"
            />
            <PlayerAgeTagsFilter
                {...commonFilterProps}
                searchTypes={searchTypes}
                desktopOnly={true}
                data-testid="search.players.filter.age-division"
            />
            {userLoggedIn && (
                <UtrFilter
                    {...commonFilterProps}
                    showExpandedUtrFilter={true}
                    desktopOnly={true}
                    data-testid="search.players.filter.utr"
                />
            )}
            <GenderFilter
                {...commonFilterProps}
                desktopOnly={true}
                data-testid="search.players.filter.gender"
            />
            {userLoggedIn && (isTennisSelected || isTennisAndPickleballSelected) && (
                <HSGradYearFilter
                    {...commonFilterProps}
                    searchTypes={searchTypes}
                    handleHSGradYearClick={_this.handleHSGradYearClick}
                    data-testid="search.players.filter.hs-grad-year"
                />
            )}
            {userLoggedIn && (
                <NationalityFilter
                    {...commonFilterProps}
                    searchTypes={searchTypes}
                    desktopOnly={true}
                    data-testid="search.players.filter.nationality"
                />
            )}
            {userLoggedIn && tennis && (
                <CollegesFilter
                    {...commonFilterProps}
                    isPowerUser={isPowerUser}
                    handleOnUpgradeToPowerClick={handleOnUpgradeToPowerClick}
                    searchTypes={searchTypes}
                    desktopOnly={true}
                    data-testid="search.players.filter.colleges"
                />
            )}
            <PlayersMoreMobileFilter
                {...commonFilterProps}
                playerFiltersAreActive={playerFiltersAreActive}
                searchTypes={searchTypes}
                isPowerUser={isPowerUser}
                userLoggedIn={userLoggedIn}
                handleUpgradeToPowerClick={handleOnUpgradeToPowerClick}
                mobileOnly={true}
                data-testid="search.players.filter.more-mobile"
            />
        </>
    );
};

export default PlayerFilters;
